<template>
  <div class="titleTxt">
    <span v-for="(item, index) in titleArr">
      <span>{{ item }}</span>
      <span class="position" v-show="index + 1 < titleArr.length">/</span>
    </span>
  </div>
</template>

<script>
export default {
  props: ["titleArr"],
  created() {},
  methods: {},
};
</script>

<style scoped>
.titleTxt span{
  font-size: 16px;
}
.position{
    display: inline-block;
    padding:0 15px 0 10px
}
</style>


// WEBPACK FOOTER //
// src/components/subTitle/index.vue